import { render, staticRenderFns } from "./QNoticesFilters.vue?vue&type=template&id=423f6f1b&scoped=true&"
import script from "./QNoticesFilters.vue?vue&type=script&lang=ts&"
export * from "./QNoticesFilters.vue?vue&type=script&lang=ts&"
import style0 from "./QNoticesFilters.vue?vue&type=style&index=0&id=423f6f1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f6f1b",
  null
  
)

export default component.exports